module.exports = __webpack_public_path__ + "img/Categories_bg_05.9c91b9de.jpg";